// Charge la base commune
import './common.js'

// Scripts librairies
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.requireJs = function (modules, cb) {
  window.require(modules, cb)
}

// Location Form
async function getLForm ($f) {
  $f.load()
  import(/* webpackChunkName: "locationForm" */ './js/components/locationForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// RDV Form
async function getRDVForm ($f) {
  $f.load()
  import(/* webpackChunkName: "newsRdvForm" */ './js/components/newsRdvForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    Waypoint.refreshAll()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').off().on('click', function () {
      const h = $('#header').height()
      const p = $(this).parents('.pajinate-nav').height()
      $('html').animate({ scrollTop: $('#step-pagination').offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
    })
  })
}

// Newsletter Form
async function getNForm ($f) {
  $f.load()
  import(/* webpackChunkName: "newsletterForm" */ './js/components/newsletterForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des alertes BS
  const $c1 = $('.alert')
  if ($c1.length) {
    $c1.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la localisation
  const $c2 = $('form[name="lForm"]')
  if ($c2.length) {
    $c2.waypoint(function () {
      getLForm($c2)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $c3 = $('form[name="cForm"]')
  if ($c3.length) {
    $c3.waypoint(function () {
      getCForm($c3)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $c4 = $('.pajinate')
  if ($c4.length) {
    $c4.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire newsletter
  const $c5 = $('form[name="nForm"]')
  if ($c5.length) {
    $c5.waypoint(function () {
      getNForm($c5)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $c6 = $('form[name="nrdvForm"]')
  if ($c6.length) {
    $c6.waypoint(function () {
      getRDVForm($c6)
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
